<template>
  <div>
    <px-view-header title="Carrinhos" :breadcrumbs="breadcrumbs"/>

    <px-carrinhos-header @refresh="refresh" @change="onChangeFilter"/>
    <px-carrinhos-list
      @update="refresh"
      :carrinhos="carrinhos"
      :loading="loading"
      @change="onChangeOptions"
      :options-list="optionsList"
    />
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import CarrinhosHeader from '@/modules/marketplace/carrinhos/CarrinhosHeader.vue';
import CarrinhosList from '@/modules/marketplace/carrinhos/CarrinhosList.vue';
import CarrinhoService from './carrinhos-marketplace-service';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Carrinhos' },
      ],
      searchText: null,
      carrinhos: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'nome',
        sortDesc: false,
      },
      loading: false,
      optionsList: {},
    };
  },
  methods: {
    refresh() {
      this.getCarrinhos();
    },
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getCarrinhos();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCarrinhos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCarrinhos() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CarrinhoService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.carrinhos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
  components: {
    pxCarrinhosHeader: CarrinhosHeader,
    pxCarrinhosList: CarrinhosList,
  },
};
</script>
